import { forwardRef } from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import {
  PROGRESS_DEFAULTS,
  PROGRESS_INDICATOR_CLASS,
  PROGRESS_ROOT_CLASS,
  type TProgressElement,
  type TProgressProps,
} from "@/ui/components/primitives/Progress/Progress.config";
import { cn } from "@/ui/lib/utils";

export const Progress = forwardRef<TProgressElement, TProgressProps>(
  (
    {
      className,
      value = PROGRESS_DEFAULTS.value,
      max = PROGRESS_DEFAULTS.max,
      ...props
    },
    ref,
  ) => {
    const remaining = 100 - Math.min(Math.max(((value ?? 0) / max) * 100, 0), 100);

    return (
      <ProgressPrimitive.Root
        ref={ref}
        data-component="Progress"
        value={value}
        max={max}
        className={cn(PROGRESS_ROOT_CLASS, className)}
        {...props}
      >
        <ProgressPrimitive.Indicator
          data-component="ProgressIndicator"
          className={PROGRESS_INDICATOR_CLASS}
          style={{ transform: `translateX(-${remaining}%)` }}
        />
      </ProgressPrimitive.Root>
    );
  },
);

Progress.displayName = ProgressPrimitive.Root.displayName;
